import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as tokens from '@tokens';
import type { TagInputProps } from './TagInput';

export const Container = styled.div<
  Pick<TagInputProps, 'isDisabled' | 'isInvalid' | 'size'>
>`
  display: flex;
  align-items: center;
  padding-block: ${(p) => (p.size === 'm' ? '7px' : '11px')};
  padding-inline: ${tokens.spacer.x2};
  border-radius: ${tokens.radius.m};
  border: 1px solid ${tokens.ALIAS_COLORS.ui_border};
  background-color: ${tokens.ALIAS_COLORS.ui_background};

  ${(props) =>
    !props.isDisabled &&
    !props.isInvalid &&
    css`
      &:hover {
        border-color: ${tokens.ALIAS_COLORS.ui_border_alt};
      }
    `}

  &:focus-within {
    ${tokens.focus()};
  }

  ${(props) =>
    props.isDisabled &&
    css`
      background-color: ${tokens.ALIAS_COLORS.ui_disabled};
      border-color: ${tokens.ALIAS_COLORS.ui_disabled};
    `}

  ${(props) =>
    props.isInvalid &&
    css`
      border-color: ${tokens.ALIAS_TEXT_COLORS.text_danger};
    `}
`;

export const InnerContainer = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: ${tokens.spacer.x0pt5};
  max-width: 100%;
`;

export const InvisbleInput = styled.input<{ tagSize: 'm' | 'l' }>`
  border: none;
  flex: 1 0;
  width: 127px;
  height: ${(props) =>
    props.tagSize === 'm' ? tokens.spacer.x3 : tokens.spacer.x4};
  background-color: inherit;
  padding: 2px ${tokens.spacer.x0pt5};

  &:focus,
  &:hover {
    border: none;
    outline: none;
  }
`;
